// Camera fit — fit camera to object bounding box.
// Split out to keep main.ts short (R15).

// @ts-ignore
import * as THREE from 'three';
// @ts-ignore
import type { OrbitControls } from 'three/examples/jsm/controls/OrbitControls.js';

export function fitCameraToObject(
  camera: THREE.PerspectiveCamera | THREE.OrthographicCamera,
  controls: OrbitControls,
  object: THREE.Object3D,
  margin = 1.5,
): void {
  const box = new THREE.Box3().setFromObject(object);
  const center = new THREE.Vector3();
  const size = new THREE.Vector3();
  box.getCenter(center);
  box.getSize(size);
  const maxDim = Math.max(size.x, size.y, size.z);
  if (maxDim === 0) return;

  const dir = new THREE.Vector3().subVectors(camera.position, controls.target).normalize();

  if ((camera as THREE.OrthographicCamera).isOrthographicCamera) {
    // Distance does not affect framing in an orthographic projection, so fitting means
    // resizing the frustum. Derive the half-height from the box's largest dimension.
    const ortho = camera as THREE.OrthographicCamera;
    const halfHeight = (maxDim / 2) * margin;
    const aspect = (ortho.right - ortho.left) / Math.max(ortho.top - ortho.bottom, 1e-6);
    ortho.top = halfHeight;
    ortho.bottom = -halfHeight;
    ortho.left = -halfHeight * aspect;
    ortho.right = halfHeight * aspect;
    ortho.zoom = 1;
    ortho.updateProjectionMatrix();
    // Park the camera far enough back that the box is inside near/far.
    const dist = Math.max(maxDim * 3, 15);
    camera.position.copy(center).addScaledVector(dir, dist);
  } else {
    const persp = camera as THREE.PerspectiveCamera;
    const dist = (maxDim / 2) / Math.tan((persp.fov * Math.PI / 180) / 2) * margin;
    camera.position.copy(center).addScaledVector(dir, dist);
  }

  controls.target.copy(center);
  controls.update();
}
